<template>
    <div class="col-lg clr2 py-4">
		<h1 class="py-3 px-5 display-4 text-light">Toplist</h1>
	</div>
</template>

<script>
export default {
	data() {
		return {
			
		}
	},
	methods: {

	}	
}
</script>
<style>
.clr2{
		background-color: #2A6A91;
	}
</style>
